import { render, staticRenderFns } from "./AlarmLetzterBesuchsbericht.vue?vue&type=template&id=f1a1b6d4"
import script from "./AlarmLetzterBesuchsbericht.vue?vue&type=script&lang=js"
export * from "./AlarmLetzterBesuchsbericht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports